import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    google: {
        families: ['Roboto:100,300,400,700:cyrillic', 'PT Sans:400,700:cyrillic']
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            VanillaSharing[button.dataset.social](shareOptions);

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* charts */
const inView = require('in-view');

import {bb} from 'billboard.js';



/* first section */
{

    const chartSelector = 'section[data-id="months"] .chart--1 .chart__container';

    const chart = bb.generate({
        bindto: chartSelector,
        tooltip: {
            show: false
        },
        legend: {
            show: false
        },
        grid: {
            y: {
                show: true
            }
        },
        data: {
            type: 'bar',
            labels: {
                position: {
                    y: -10
                }
            },
            columns: [
                ['months', 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            ],
            colors: {
                months: '#957BDA'
            }
        },
        axis: {
            x: {
                type: 'category',
                categories: [
                    'январь',
                    'февраль',
                    'март',
                    'апрель',
                    'май',
                    'июнь',
                    'июль',
                    'август',
                    'сентябрь',
                    'октябрь',
                    'ноябрь',
                    'декабрь'
                ],
                tick: {
                    rotate: document.body.clientWidth <= 425 || document.body.clientHeight <= 425 ? 75 : 0,
                    multiline: false
                }
            }
        }
    });

    const chartData = [
        ['months', 58858, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 0, 0, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 0, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 0, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 0, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 166796, 0, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 166796, 144976, 0, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 166796, 144976, 108361, 0, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 166796, 144976, 108361, 93011, 0],
        ['months', 58858, 69540, 70784, 93304, 45770, 124229, 143321, 166796, 144976, 108361, 93011, 90142]
    ];

    let firstTime = true;

    inView(chartSelector)
        .on('enter', () => {

            if (firstTime) {
                let promise = Promise.resolve();
                chartData.forEach(item => {
                    promise = promise.then(() => {
                        chart.load({
                            columns: [
                                item
                            ]
                        });
                        return new Promise(function (resolve) {
                            requestAnimationFrame(resolve);
                        });
                    });
                });
                firstTime = false;
            }

        });

    inView('.section[data-id="months"] .map__content q')
        .on('enter', elem => {
            elem.setAttribute('data-inview', 'true');
        });

    inView('.map__map')
        .on('enter', elem => {

            let promise = Promise.resolve();
            ['1', '2', '3', '0'].forEach(item => {
                promise = promise.then(() => {
                    elem.setAttribute('data-hover', item);
                    return new Promise(function (resolve) {
                        setTimeout(resolve, 400);
                    });
                });
            });

        });

    document.querySelectorAll('.map__desc p').forEach((item, index) => {
        item.addEventListener('mouseover', () => {
            document.querySelector('.map__map').setAttribute('data-hover', index + 1);
        });
        item.addEventListener('mouseout', () => {
            document.querySelector('.map__map').removeAttribute('data-hover');
        });
    });

}



/* second section */
{

    const chartSelector = 'section[data-id="menandwomen"] .chart--1 .chart__container';

    const chart = bb.generate({
        bindto: chartSelector,
        tooltip: {
            show: false
        },
        legend: {
            show: false
        },
        donut: {
            label: {
                show: false
            }
        },
        data: {
            type: 'donut',
            columns: [
                ['data1', 0],
                ['data2', 0],
                ['data3', 0],
                ['data4', 0],
                ['data5', 0],
                ['data6', 0]
            ],
            colors: {
                data1: '#90E0FC',
                data2: '#957BDA',
                data3: '#FECB00',
                data4: '#D5CAF0',
                data5: '#FCF1E2',
                data6: '#d2f1fc'
            },
            onover: (d) => {
                document.querySelector(`.section[data-id="menandwomen"] .chart--1 .item[data-id="${d.id.replace('data', '')}"]`).setAttribute('data-hover', 'true');
            },
            onout: (d) => {
                document.querySelector(`.section[data-id="menandwomen"] .chart--1 .item[data-id="${d.id.replace('data', '')}"]`).removeAttribute('data-hover');
            }
        }
    });

    let firstTime = true;

    inView(chartSelector)
        .on('enter', () => {

            if (firstTime) {
                setTimeout(() => {
                    chart.load({
                        columns: [
                            ['data1', 69],
                            ['data2', 17],
                            ['data3', 9],
                            ['data4', 3.5],
                            ['data5', 1],
                            ['data6', 0.5]
                        ]
                    });
                }, 400);
                firstTime = false;
            }

        });

    inView('.section[data-id="menandwomen"] .chart--1 .items')
        .on('enter', elem => {
            elem.setAttribute('data-inview', 'true');
        });

        document.querySelectorAll('.section[data-id="menandwomen"] .chart--1 .item').forEach(item => {
            item.addEventListener('mouseover', () => {
                chart.focus(`data${item.dataset.id}`);
            });
            item.addEventListener('mouseout', () => {
                chart.revert();
            });
        });

}



/* third section */
{
    inView('.section[data-id="celebrations"] .items')
        .on('enter', elem => {
            elem.setAttribute('data-inview', 'true');
        });
}



/* fourth section */
{

    const chartSelector = 'section[data-id="age"] .chart--1 .chart__container';

    const chart = bb.generate({
        bindto: chartSelector,
        tooltip: {
            show: false
        },
        legend: {
            show: false
        },
        grid: {
            y: {
                show: true
            }
        },
        data: {
            type: 'bar',
            labels: {
                position: {
                    y: -5
                }
            },
            columns: [
                ['women', 0, 0, 0, 0, 0, 0, 0],
                ['men', 0, 0, 0, 0, 0, 0, 0]
            ],
            colors: {
                men: '#90E0FC',
                women: '#957BDA'
            }
        },
        axis: {
            x: {
                type: 'category',
                categories: [
                    '16-19',
                    '20-24',
                    '25-29',
                    '30-34',
                    '35-39',
                    '40-44',
                    '45-49'
                ],
                tick: {
                    rotate: document.body.clientWidth <= 425 || document.body.clientHeight <= 425 ? 75 : 0,
                    multiline: false
                }
            }
        }
    });

    const chartData = [
        [
            ['women', 75, 0, 0, 0, 0, 0, 0],
            ['men', 17, 0, 0, 0, 0, 0, 0]
        ],
        [
            ['women', 75, 391, 0, 0, 0, 0, 0],
            ['men', 17, 213, 0, 0, 0, 0, 0]
        ],
        [
            ['women', 75, 391, 639, 0, 0, 0, 0],
            ['men', 17, 213, 544, 0, 0, 0, 0]
        ],
        [
            ['women', 75, 391, 639, 699, 0, 0, 0],
            ['men', 17, 213, 544, 690, 0, 0, 0]
        ],
        [
            ['women', 75, 391, 639, 699, 702, 0, 0],
            ['men', 17, 213, 544, 690, 745, 0, 0]
        ],
        [
            ['women', 75, 391, 639, 699, 702, 694, 0],
            ['men', 17, 213, 544, 690, 745, 778, 0]
        ],
        [
            ['women', 75, 391, 639, 699, 702, 694, 685],
            ['men', 17, 213, 544, 690, 745, 778, 799]
        ]
    ];

    let firstTime = true;

    inView(chartSelector)
        .on('enter', () => {

            if (firstTime) {
                let promise = Promise.resolve();
                chartData.forEach(item => {
                    promise = promise.then(() => {
                        chart.load({
                            columns: item
                        });
                        return new Promise(function (resolve) {
                            requestAnimationFrame(resolve);
                        });
                    });
                });
                firstTime = false;
            }

        });

    inView('.section[data-id="age"] .item__chart .donut__segment')
        .on('enter', elem => {
            elem.setAttribute('stroke-dasharray', `${elem.dataset.value} 100`);
        });

}



/* movie */
import YouTubePlayer from 'youtube-player';

{

    document.querySelector('#player').addEventListener('click', () => {
        const player = YouTubePlayer('player', {
            videoId: 'c3VxQwItiWg',
            playerVars: {
                showinfo: 0,
                rel: 0,
                playsinline: 1,
                modestbranding: 1
            }
        });
        player.playVideo();

        analyticsEvent('Button', 'click', {eventLabel: 'Play'});
    });

    document.querySelector('.movie__buy').addEventListener('click', e => {
        e.preventDefault();

        ticketManager.creationSchedule('abb7bf0d-7cd7-4d36-8a5f-a6f0300eaabb',92555,0,17);

        analyticsEvent('Button', 'click', {eventLabel: 'RamblerKassa'});
    });

}



/* scroll depth */
const jQuery = require('jquery');

require('../node_modules/scroll-depth/jquery.scrolldepth.min.js');

jQuery(() => {
    jQuery.scrollDepth({
        percentage: true,
        userTiming: true,
        pixelDepth: false,
        eventHandler: (data) => {
            analyticsEvent(data.eventCategory, data.eventAction, {eventLabel: data.eventLabel});
        }
    });
});



/* links */
document.querySelectorAll('a[href*="http://perepoloh.afisha.ru/"]').forEach(item => {
    item.addEventListener('click', () => {
        analyticsEvent('Link', 'click', {eventLabel: 'AfishaPerepoloh'});
    });
});



// WEBPACK FOOTER //
// ./app.js